import { isUserAppState, UserAppState } from './AppState'
import { logErrorDebug } from '../debug/debugLogging'
import { v4 as uuidv4 } from 'uuid'

const LocalStorageStateKey = 'clipsal-iconic-builder.userState'

export function getLocalStorageSavedState(): UserAppState | null {
  try {
    const data = localStorage.getItem(LocalStorageStateKey)
    if (!data) {
      return null
    }

    const value: unknown = JSON.parse(data)

    // Assert that value is UserAppState and assign a default value for added properties
    // to prevent users with old localStorage data losing their data when the code is pushed live.
    const castValue = value as UserAppState

    castValue.typeSelectorTutorialDismissed = castValue.typeSelectorTutorialDismissed ?? false
    if (isUserAppState(castValue)) {
      if (typeof castValue.listId !== 'string' || castValue.listId.trim() === '') {
        castValue.listId = uuidv4()
      }

      return castValue
    }
  } catch (e) {
    logErrorDebug('error loading state from localstorage', e)
  }

  return null
}

export function setLocalStorageSavedState(state: UserAppState | null) {
  try {
    if (state == null) {
      localStorage.removeItem(LocalStorageStateKey)
    } else {
      localStorage.setItem(LocalStorageStateKey, JSON.stringify(state))
    }
  } catch (err) {
    logErrorDebug('error saving state to localstorage', err)
  }
}
